<template>
  <div>
    <hexachat
      v-show="!handedOver && isReady"
      :settings="settings"
      :chat="chat"
      :colors="colors"
      :widget="widget"
      @send="handleSend"
      @opened="opened"
      @closed="closed"
      @scrollToTop="loadMore"
      @wantToConnect="doConnect"
    >
      <template v-slot:header>
        <img
          class="sc-header--img"
          src="https://dimelo.s3.amazonaws.com/custom-v2/orangetunisie/chat/avatar-otn.png"
          alt
        />
        <div class="sc-header--title">
          <span class="sc-header--title-badge">Une question ?</span>
          Des questions ? Besoin d'aide ?
        </div>
        <div class="sc-header--close-button" @click="widget.isOpen = false"></div>
      </template>
      <template v-slot:pre-chat>
        <user-subscription :colors="colors" @submit="handleSubscription" :greetings="settings.greeting_message" />
      </template>
      <template v-slot:launcher>
        <div
          class="dimelo_chat_item_container dimelo_chat_button_container dimelo_chat_mode_offline"
          v-show="!widget.isOpen"
        >
          <div class="item-reset button-wrapper button-first-step">
            <div class="button-inner-wrapper">
              <div class="custom-button-action">
                <chat-icon />
              </div>
            </div>
          </div>
        </div>
      </template>
    </hexachat>
  </div>
</template>

<script>
import hexachat from "@hexabot/chat";
import UserSubscription from "./components/UserSubscription";
import ChatIcon from "./components/ChatIcon";
import colors from "./utils/colors";
export default {
  name: "app",
  components: {
    hexachat,
    UserSubscription,
    ChatIcon
  },
  data() {
    return {
      colors: {},
      chat: {
        participants: [
          {
            id: "chatbot",
            name: "Hexabot",
            imageUrl: "https://dimelo.s3.amazonaws.com/custom-v2/orangetunisie/chat/avatar-otn.png"
          }
        ],
        messages: [],
        message: "",
        file: null,
        payload: null,
        connectionState: 0,
        watermarks: false
      },
      settings: {
        showEmoji: false,
        showFile: true,
        showLocation: true,
        title: "hexabot!",
        titleImageUrl: "https://dimelo.s3.amazonaws.com/custom-v2/orangetunisie/chat/avatar-otn.png",
        menu: [],
        placeholder: { en: "Send a message...", fr: "Envoyer un message..." },
        greeting_message: '',
        // showTypingIndicator: true,
        // alwaysScrollToBottom: true,
        // focusOnOpen: true,
        // inputDisabled: false,
        // placeholder: {en: 'Type something...', fr: 'Écrivez quelque chose...'},
      },
      widget: {
        isOpen: false,
        screen: "prechat",
        scroll: 100
      },
      serverDate: new Date().toISOString(),
      token: process.env.VUE_APP_TOKEN,
      lastReadMessageIndex: 22,	
      isReady: false,
      user: null,
      subscribed: false,
      handoverAvailability: true,
      handedOver: false,
      isMaster: true, // `true` if this is the active browser's window, `false` if it's a passive window
    };
  },
  socket: {
    events: {
      disconnect() {
        this.chat.connectionState = 0
      },
      connect() {
        this.chat.connectionState = 3
      },
      message(message) {
        // Is the message is sent from the current window ? Master/Slave
        let exists = this.chat.messages.find((m) => m.mid === message.mid);
        if (!exists && message.author === this.user.id) {
          this.isMaster = false;
        }

        // Sync with Dimelo only if current window is master
        if (this.isMaster) {
          if (message.author !== this.user.id) {
            this.handleDimeloMessageReceived(message);
          } else {
            this.handleDimeloMessageSent(message);
          }
        } else if (message.handover) {
          // Quickfix to Handover in a slave window
          this.dimeloToggleHandover(true);
          window._chatq.push([
            "_addMessage",
            {
              body: '⏳ Transfert en cours ...',
              agent: false,
              engage: true,
              sync: true
            }
          ]);
          return;
        }

        // Add message to the thread
        message.direction = this.getMessageDirection(message.author);
        this.chat.newMessage = message;
        this.markAsDelivered(message.mid);
        if (this.widget.isOpen && this.chat.messages.length) {
          this.markAsRead();
        }
        this.serverDate = message.createdAt;
      },
      typing(status) {
        this.chat.watermarks = status;
      },
      settings(settings) {
        this.chat.participants[0].imageUrl = settings.avatar_url
        this.settings.showEmoji = settings.show_emoji;
        this.settings.showFile = settings.show_file;
        this.settings.showLocation = settings.show_location;
        this.settings.title = settings.window_title;
        this.settings.titleImageUrl = settings.avatar_url;
        this.settings.menu = settings.menu;
        this.settings.allowedUploadTypes = settings.allowed_upload_types;
        this.settings.allowedUploadSize = settings.allowed_upload_size;
        // need server translations
        this.settings.greeting_message = settings.greeting_message;

        if (colors[settings.theme_color]) {
          this.colors = colors[settings.theme_color];
        }
        this.isReady = true
      }
    }
  },
  beforeCreate() {
    this.$io.socket.get(
      `${process.env.VUE_APP_API_PATH}/webhook/offline?_get=settings&verification_token=${process.env.VUE_APP_TOKEN}`,
      null,
      (settings, jwres) => {
        if (jwres.error) {
          // eslint-disable-next-line
          return console.error(jwres.error);
        }
        this.chat.participants[0].imageUrl = settings.avatar_url
        this.settings.showEmoji = settings.show_emoji;
        this.settings.showFile = settings.show_file;
        this.settings.showLocation = settings.show_location;
        this.settings.title = settings.window_title;
        this.settings.titleImageUrl = settings.avatar_url;
        this.settings.menu = settings.menu;
        // need server translations
        this.settings.greeting_message = settings.greeting_message;
        // Set server date to deal timezone diff
        this.serverDate = settings.server_date

        if (colors[settings.theme_color]) {
          this.colors = colors[settings.theme_color];
        }
        this.isReady = true
      }
    );
  },
  mounted() {
    if (localStorage.sc_user && localStorage.sc_expiresAt) {
      try {
        if (JSON.parse(localStorage.sc_expiresAt) > new Date()) {
          this.handleSubscription(JSON.parse(localStorage.sc_user));
        }
      } catch (err) {
        // eslint-disable-next-line
        console.warn("Could not resubscribe existing user", err);
      }
    }
    this.initDimeloHooks();
  },
  watch: {
    "chat.connectionState" (newState, oldState) {
      if (oldState === 3) {
        this.$io.disconnect()
      }
    }
  },
  methods: {
    initDimeloHooks() {
      // Override chat queue push to capture Dimelo events
      window._internal_chatq = window._internal_chatq || [];
      window._internal_chatq.push = function(_event) {
        const data = _event.slice();
        const event = new CustomEvent("dimelo:" + data[0], { detail: data[1] });
        window.dispatchEvent(event);
        return Array.prototype.push.apply(this, arguments);
      };
      window._chatq = window._chatq || [];
      window._chatq.push = function(_event) {
        const data = _event.slice();
        const event = new CustomEvent("dimelo:" + data[0], { detail: data[1] });
        window.dispatchEvent(event);
        return Array.prototype.push.apply(this, arguments);
      };
      // window._chatq.push(['_onEvent', 'started', function (data) {
      //   //...
      // }])
      // Sync messages when conversation is handedover
      window._chatq.push(['_onEvent', 'message_sent', () => {

        this.dimeloSyncMessage(true);
      }])
      window._chatq.push(['_onEvent', 'message_received', () => {
        this.dimeloSyncMessage(false);
      }])
      window._chatq.push(['_onEvent', 'chat_closed', () => {
        this.handleDisconnect();
      }])
      // Listen to register status,
      // if activation_probability=1 then agents are available
      // else, no agent is available
      window.addEventListener("dimelo:_registerStatus", event => {
        const triggers = event.detail.triggers;
        const key = Object.keys(triggers)[0];
        this.handoverAvailability = !!triggers[key].activation_probability;
      });
    },
    dimeloSyncMessage(isSent) {
      // Sync messages if conversation is handed over only for active window
      if (this.isMaster && this.handedOver) {
        const lastMessage = this.dimeloLastMessage();
        if (lastMessage && lastMessage.includes('Transfert en cours')) {
          this.send({
            type: 'text',
            data: { text: lastMessage },
            direction: isSent ? 'sent' : 'received',
            sync: true,
            author: isSent ? null : 'chatbot',
          });
        }
      }
    },
    dimeloLastMessage() {
      const jQuery = window.Dimelo.Chat.jQuery;
      const dimeloChatWrapper = jQuery('.dimelo-chat-wrapper');
      const lastMessage = dimeloChatWrapper.find(".dimelo-chat-message-body").last().text().trim();
      return lastMessage;
    },
    dimeloStart(profile) {
      this.dimeloToggleHandover(profile.assignedTo);
      window._internal_chatq.push([
        "_activateTrigger",
        {
          id: "5e259d593298c923dd1edb5c",
          label: "Ciblage de test chatbot",
          supported_modes: ["online"],
          actions: [{ name: "SHOW_CHAT_OPEN" }],
          processings: [],
          always: true,
          debug: false,
          last: false,
          once: false
        }
      ]);
      if (!profile.assignedTo) {
        // window._internal_chatq.push(["_start"]);
        // window._internal_chatq.push(["_registerStatus", {"validity":10,"triggers":{"5e259d593298c923dd1edb5c":{"activation_probability":1}}}]);
        window._chatq.push([
          "_setIdentity",
          {
            screenname: profile.first_name + " " + profile.last_name,
            extra_values: {
              custom_firstname: profile.first_name,
              custom_lastname: profile.last_name,
              custom_phone_number: ""
            }
          }
        ]);
      }
    },
    dimeloToggleHandover(handover) {
      if (handover) {
        // Stop polling
        this.$io.disconnect()
      }
      let dimeloChatWrapper = window.document.getElementsByClassName(
        "dimelo-chat-wrapper"
      );
      if (dimeloChatWrapper && dimeloChatWrapper.length > 0) {
        dimeloChatWrapper[0].style.display = handover ? "block" : "none";
      } else {
        // eslint-disable-next-line
        console.warn("Hexabot: Could not toggle handover conversation");
        // Retry...
        setTimeout(() => {
          this.dimeloToggleHandover(handover);
        }, 500);
      }
      this.handedOver = handover;
    },
    serializeForDimelo(message) {
      let serialized = message.data.text ? message.data.text : "";
      serialized += message.data.elements
        ? message.data.elements.map(element => `- ${element.title}`).join("\n")
        : "";
      serialized += message.data.url ? message.data.url : "";
      serialized += message.data.coordinates
        ? `Latitude=${message.data.coordinates.lat}\nLongitude=${message.data.coordinates.lng}`
        : "";
      return serialized;
    },
    handleDimeloMessageSent(message) {
      // Ignore Sync messages to avoid loopback
      if (!this.handedOver) {
        window._chatq.push([
          "_addMessage",
          { body: this.serializeForDimelo(message), agent: false, engage: false }
        ]);  
      }
    },
    handleDimeloMessageReceived(message) {
      // Ignore Sync messages to avoid loopback
      if (!this.handedOver) {
        window._chatq.push([
          "_addMessage",
          {
            body: this.serializeForDimelo(message),
            agent: true,
            engage: this.handedOver
          }
        ]);
        // Conversation will be handed over ?
        if (message.handover) {
          this.dimeloToggleHandover(message.handover);
          // In case of handover, keep track of lastest text messages
          // the message will be sent to Dimelo to trigger queueing process and sets a title for the thread
          // Sending message with engage=true will add user to dimelo queue (Yes mind blowing xD)
          let recap = this.chat.messages
            .filter(m => m.direction === "sent" && m.type === "text")
            .map(m => m.data.text)
            .slice(-3)
            .join("\n");
          window._chatq.push([
            "_addMessage",
            { body: `Résumé :\n${recap}`, agent: false, engage: true }
          ]);
        }
      }      
    },
    handleSend(e, source, data) {
      this.send(data);
    },
    doConnect() {
      this.$io.disconnect()
      this.longPooling(process.env.VUE_APP_API_PATH + '/webhook/offline?_get=polling&verification_token=' + process.env.VUE_APP_TOKEN, 1, this.serverDate, true)
    },
    getMessageDirection (authorId) {
      // The new attribute "foreign_id" introduced to the Subscriber is the actual author Id
      // For retro-compatibility, we keep the user.id comparison  but needs to be removed in the future
      return (authorId === this.user.id || authorId === this.user.foreign_id) ? 'sent' : 'received';
    },
    send(message) {
      this.isMaster = true;
      message.author = message.author || this.chat.participants[1].id;
      this.$io.socket.post(
        process.env.VUE_APP_API_PATH +
          "/webhook/offline/?verification_token=" +
          this.token,
        message,
        (response, jwres) => {
          if (jwres.error || typeof response !== "object" || !response.type) {
            this.$io.disconnect();
          } else {
            response.direction = this.getMessageDirection(response.author);
            response.sync = !!message.sync;
            this.chat.newMessage = response;
          }
        }
      );
    },
    handleSubscription(user, sendGetStarted = false, getMessages = true) {
      this.widget.screen = "chat";
      if (this.chat.connectionState !== 3) {
        this.chat.connectionState = 2;
      }
      this.$io.socket.get(
        `${process.env.VUE_APP_API_PATH}/webhook/offline/?verification_token=${this.token}`,
        {first_name: user.first_name, last_name: user.last_name},
        (data, jwres) => {
          if (jwres.error) {
            // eslint-disable-next-line
            console.warn(
              `Could not subscribe`,
              jwres.error
            );
            this.chat.connectionState = 0;
            this.widget.screen = "pre-chat";
            return
          }
          this.user = data.profile;
          this.chat.participants[1] = data.profile;
          this.handedOver = !!data.profile.assignedTo;

          this.chat.messages = data.messages.map(message => {
            return {
              ...message,
              direction: this.getMessageDirection(message.author),
            }
          })
          if (getMessages) {
            this.doConnect()
            this.chat.messages = data.messages.map(message => {
              return {
                ...message,
                direction: this.getMessageDirection(message.author),
              }
            })
          }
          try {
            localStorage.sc_user = JSON.stringify(data.profile);
            localStorage.sc_expiresAt = new Date().valueOf() + 3600000;
            this.dimeloStart(data.profile);
          } catch (err) {
            // eslint-disable-next-line
            console.warn("Could not persiste user locally", err);
          }
          if (sendGetStarted) {
            this.send({
              type: "postback",
              data: {
                text: this.$t('GetStarted'),
                payload: "GET_STARTED"
              }
            });
          }
          this.isReady = true;
        }
      );
    },
    handleDisconnect() {
      // Destroy session
      this.$io.socket.get(
        `${process.env.VUE_APP_API_PATH}/webhook/offline/?verification_token=${this.token}&_disconnect=true`,
        {},
        (data, jwres) => {
          if (jwres.error) {
            // eslint-disable-next-line
            console.error(jwres.error);
          }
          // Clear local storage
          localStorage.removeItem('sc_user');
          localStorage.removeItem('sc_expiresAt');
        })
    },
    loadMore() {
      const since = this.chat.messages[0].createdAt
      this.$io.socket.get(
        `${process.env.VUE_APP_API_PATH}/webhook/offline/?verification_token=${this.token}&history=true`,
        {since},
        (data, jwres) => {
          if (jwres.error) {
            // eslint-disable-next-line
            console.error(jwres.error);
          }
          const lengthBefore = this.chat.messages.length
          this.chat.messages.unshift(...data.messages.map(message => {
            return {
              ...message,
              direction: this.getMessageDirection(message.author),
            }
          }))
          const lengthAfter = this.chat.messages.length
          // approximation
          this.widget.scroll = 100 - Math.round(100 * lengthBefore / lengthAfter)
        }
      );
    },
    markAsDelivered(mid, retrials = 0) {
      const data = {
        mid,
        type: "delivery"
      };
      const retry = retrials < 4;
      this.$io.socket.post(
        `${process.env.VUE_APP_API_PATH}/webhook/offline/?verification_token=${this.token}`,
        data,
        (response, jwres) => {
          if (jwres.error) {
            // eslint-disable-next-line
            console.warn(
              `Could not mark message ${mid} as delivered`,
              jwres.error
            );
            if (retry) {
              ++retrials;
              const delay = (3 * retrials) ** 2; // 9..36..81..144 (sec)
              // eslint-disable-next-line
              console.info(`retrying in ${delay} seconds`);
              setTimeout(() => {
                this.markAsDelivered(mid, retrials);
              }, delay * 1000);
            }
          }
          const message = this.chat.messages.find(
            message => message.mid === mid
          );
          if (!message) {
            // eslint-disable-next-line
            console.warn(`could not find message ${mid}`);
          } else {
            this.$set(message, "delivery", true);
          }
        }
      );
    },
    markAsRead(retrials = 0) {
      const watermark = +new Date();
      const messagesToRead = []
      for (let i = this.chat.messages.length - 1; i > -1; --i) {      
        let message = this.chat.messages[i]      
        if (message.direction === "received") {
          if (message.read) {
            break;
          }
          if (new Date(message.createdAt).valueOf() <= watermark) {
            messagesToRead.push(message)
          }
        }
      }    
      if (!messagesToRead.length) {
        return
      }  
      const data = {
        watermark,
        type: "read"
      };
      const retry = retrials < 4;
      this.$io.socket.post(
        `${process.env.VUE_APP_API_PATH}/webhook/offline/?verification_token=${this.token}`,
        data,
        (response, jwres) => {
          if (jwres.error) {
            // eslint-disable-next-line
            console.warn(`Could not mark messages as read`, jwres.error);
            if (retry) {
              ++retrials;
              const delay = (3 * retrials) ** 2; // 3..9..27..144 (sec)
              // eslint-disable-next-line
              console.info(`retrying in ${delay} seconds`);
              setTimeout(() => {
                this.markAsRead(retrials);
              }, delay * 1000);
            }
          }
          messagesToRead.forEach(message => {
            this.$set(message, 'read', true)
          })
        }
      );
    },
    opened() {
      this.widget.isOpen = true;
      this.markAsRead();
    },
    closed() {
      this.widget.isOpen = false;
    }
  },
  beforeDestroy() {
    this.$io.disconnect()
  }
};
</script>

<style>
.dimelo-chat-wrapper {
  display: none;
}

.sc-launcher-wrapper {
  z-index: 10000;
  position: fixed;
  right: 0;
  bottom: 200px;
}

.sc-launcher-wrapper .custom-button-action {
  box-shadow: 0 0 6px rgb(5 5 5 / 25%);
  background: #f16e00;
  padding: .5rem;
  display: inline-block;
  position: absolute;
  z-index: 200;
  right: 0;
  top: 0;
  box-sizing: border-box;
  border-top-left-radius: 8px;
  border-bottom-left-radius: 8px;
}

.sc-launcher-wrapper .custom-button-action {
  transition: all 0.2s ease-in-out;
}
.sc-launcher-wrapper .custom-button-action:hover {
  transform: scale(1.05);
}

.sc-launcher-wrapper .second-b:before {
  background: url(https://dimelo.s3.amazonaws.com/custom-v2/orangetunisie/chat/arrow-orange.png)
    no-repeat 0 0;
  background-size: 26px;
}

.sc-launcher-wrapper .button-close {
    position: absolute;
    top: 0;
    right: -18px;
    line-height: 0.8;
    cursor: pointer;
    font-size: 150%;
    opacity: 0.5;
    color: #333333;
}

.sc-launcher-wrapper .custom-button-action:hover {
  cursor: pointer;
}

.sc-launcher-wrapper .button-close:hover {
  opacity: 1;
}

.sc-chat-window.opened {
  font-size: 14px;
  bottom: 0 !important;
  height: 410px !important;
  border-top-right-radius: 2px !important;
  border-top-left-radius: 2px !important;
  border-bottom-right-radius: 0 !important;
  border-bottom-left-radius: 0 !important;
  border: solid;
  border-width: 0 1px;
  border-color: #d6d9d9;
  background: #f0f2f2;
  -moz-box-shadow: 0 0 2px rgba(126, 137, 149, 0.5);
  -webkit-box-shadow: 0 0 2px rgba(126, 137, 149, 0.5);
  box-shadow: 0 0 2px rgba(126, 137, 149, 0.5);
  z-index: 9999;
}

.sc-header {
  border-top-right-radius: 2px !important;
  border-top-left-radius: 2px !important;
  -webkit-box-shadow: none;
  box-shadow: none;
  padding: 0 !important;
}

.sc-header--img {
  max-width: none !important;
  max-height: none !important;
  padding: 0 !important;
  width: 50px;
  height: 50px;
  border-radius: 50px;
  border: 2px solid white;
  display: block;
  position: absolute;
  z-index: 300;
  top: 100%;
  left: 50%;
  transform: translate(-50%, -50%) !important;
  box-shadow: 1px 2px 2px rgba(0, 0, 0, 0.2);
}

.sc-header--title {
  position: static;
  line-height: 71px;
  font-size: 18px !important;
  font-weight: bold;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  top: 50%;
  left: 16px;
  right: 80px;
  text-align: center;
}
.sc-header--title .sc-header--title-badge {
  background: black;
  color: white;
  padding: 10px 14px;
  font-size: 18px;
  line-height: 20px;
  position: absolute;
  z-index: 200;
  border: 2px solid white;
  display: inline-block;
  left: -10px;
  top: -30px;
}
.sc-header--title .sc-header--title-badge::after {
  content: "";
  display: block;
  width: 30px;
  height: 20px;
  background: url(https://dimelo.s3.amazonaws.com/custom-v2/orangetunisie/chat/arrow-black.png)
    no-repeat 0 0;
  background-size: 24px;
  position: absolute;
  z-index: 300;
  top: 38px;
  left: 88px;
}
.sc-header--close-button {
  position: absolute;
  top: 10px;
  right: 10px;
  background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQBAMAAADt3eJSAAAAA3NCSVQICAjb4U%2FgAAAACXBIWXMAAA3XAAAN1wFCKJt4AAAAGXRFWHRTb2Z0d2FyZQB3d3cuaW5rc2NhcGUub3Jnm%2B48GgAAACFQTFRF%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2Ff4DHbwAAAAp0Uk5TABUWFyC309TV1gWPmagAAABDSURBVAhbY2DABK4GDAzMIUBG1GQGBsulQIblCgWmLiCHgbmrUHyFAUiR%2BrKsIrBqxqxlAqgMmBRcMVw73EC4FegAAEtVEt2gSNC%2FAAAAAElFTkSuQmCC);
  background-repeat: no-repeat;
  background-position: center;
  margin: 0 !important;
  width: 16px !important;
  height: 16px !important;
}
.sc-chat-window {
  max-width: 300px !important;
}
.sc-chat-window .user-subscription {
  margin: 0;
}
.sc-chat-window .user-subscription .user-subscription-title {
  margin: 0;
  padding: 0.5rem;
}
.sc-chat-window .user-subscription .user-subscription-form-input {
  border-radius: 4px;
  border: 1px solid #a6a6a6;
}
.sc-chat-window .user-subscription .user-subscription-form-input::placeholder,
.sc-chat-window .user-subscription .user-subscription-form-input::-webkit-input-placeholder {
  color: #a6a6a6 !important;
}
.sc-chat-window .user-subscription .user-subscription-form-button-submit {
  margin: 0 auto;
  border-radius: 4px;
}
.sc-chat-window .sc-message-list {
  padding: 0;
}
.sc-chat-window .sc-message-list .sc-message .sc-message--text {
  border-radius: 2px !important;
  font-size: 12px !important;
  padding: 8px;
}
.sc-chat-window .sc-message-list .sc-message .sc-message--text .sc-message--text-content {
  margin: 0!important;
}
.sc-chat-window .sc-message-list .sc-message .sc-message--file-download img {
  filter: invert(1);
}
.sc-chat-window .sc-message-list .sc-message .sc-message--avatar {
  width: 40px;
  height: 40px;
  margin-right: 5px;
  border: 2px solid white;
  box-shadow: 1px 2px 2px rgba(0, 0, 0, 0.2);
}
.sc-chat-window .sc-message-list .sc-message .sc-message--wrapper {
  margin-bottom: .75rem;
  max-width: calc(100% - 60px);
}
.sc-chat-window .sc-message-list .sc-message .sc--status {
  display: none;
}
.sc-chat-window .sc-message-list .sc-message .sc-message--file-download img {
  -webkit-filter: invert(0) !important;
  filter: invert(0) !important;
}
.sc-chat-window .sc-message-list .sc-message .sc-message--carousel-element .sc-message--title {
  font-size: 1.5rem !important;
  padding: .25rem !important;
  margin: 0 !important;
}
.sc-chat-window .sc-message-list .sc-message .sc-message--list-element-content .sc-message--title {
  font-size: 1.5rem !important;
  padding: 1rem !important;
  margin: 0 !important;
}
.sc-chat-window .sc-message-list .sc-message .sc-message--list-element-content p {
  margin: 0 !important;
  padding: 0 1rem !important;
}
.sc-chat-window .sc-message-list .sc-message .sc-message--carousel-element-image {
  background-size: contain !important;
  height: 100px !important;
}
.sc-chat-window .sc-message-list .sc-message .sc-message--list {
  max-width: 90% !important;
}
.sc-chat-window .sc-user-input-wrapper {
  border-top: 1px solid #ddd;
}
.sc-chat-window .sc-user-input-wrapper .sc-suggestions-row {
  border-bottom: 1px solid #ddd;
}
.sc-chat-window .sc-user-input-wrapper .sc-menu-content {
  bottom: 39px !important;
}
.sc-chat-window .sc-user-input-wrapper .sc-user-input {
  min-height: 18px !important;
  background-color: #fff !important;
}
.sc-chat-window .sc-user-input-wrapper .sc-user-input .sc-user-input--text {
  padding: 10px;
  font-size: 12px;
  line-height: 18px;
  width: 180px !important;
}
.sc-webview--button {
  font-size: 16px !important;
}
</style>
